/** The individual plans this app can sell through Stripe. */
export type PaidPlan = 'premium' | 'pro';

/** Order the plans are offered in, cheapest paid plan first. */
export const PAID_PLAN_ORDER: PaidPlan[] = ['premium', 'pro'];
